import { pick } from 'ramda';
import { v4 as uuidv4 } from 'uuid';

import { MIDNIGHT, toSeconds } from '../utils/date';
import { NO_STOP_INDEX } from '../constants/variables';
import { getParcelsWithUpdatedParcelIndexes, isAddRequest } from './request';
import { getHighestSequenceNumber, getHighestStopNumber } from './stop';
import { originalTypes } from '../enums/stopTypes';

export const findLeadParcel = (parcels) => {
  let bestTime = MIDNIGHT;
  let leadParcel = {};

  parcels.forEach((parcel) => {
    if (toSeconds(parcel.serviceEndTime) < toSeconds(bestTime)) {
      bestTime = parcel.serviceEndTime;
      leadParcel = parcel;
    } else if (toSeconds(parcel.serviceEndTime) === toSeconds(bestTime)) {
      if (parcel.priority < leadParcel.priority) {
        bestTime = parcel.serviceEndTime;
        leadParcel = parcel;
      }
    }
  });

  return leadParcel;
};

export const nonCadScannedParcel = (parcel) => !parcel.cadScanned;

export const isContinuousWaveParcel = ({ parcelStatus }) =>
  parcelStatus === 'B';

export const convertParcelStatus = (parcel) => (parcel.loaded && 'L') || null;

export const getBulkTestIdString = (isBulk, isBulkDisabled) => {
  const nameString = 'bulk-checkbox';

  if (isBulkDisabled) {
    return `${nameString}-disabled`;
  }

  return isBulk ? `${nameString}-checked` : `${nameString}-unchecked`;
};

export const formatParcelTransferData = (
  { parcelCode, routeDate, labelNumber, serviceEndTime, serviceStartTime },
  stopId
) => ({
  parcelCode,
  routeDate,
  labelNumber,
  serviceEndTime,
  serviceStartTime,
  sourceParcelStopId: stopId,
});

export const getOriginalParcelsTransferData = ({ stop }) => {
  const parcels = {};
  stop.forEach(({ stopId, parcel }) => {
    parcel.forEach((item) => {
      parcels[item.parcelCode] = formatParcelTransferData(item, stopId);
    });
  });

  return parcels;
};

const getOriginalParcelData = (originalParcels, stop) => (parcel) =>
  originalParcels[parcel.parcelCode] ||
  formatParcelTransferData(parcel, stop.stopId);

export const getRelatedInitialParcels = ({
  stop,
  originalParcels,
  processedParcels,
}) =>
  (processedParcels || stop.parcel).map(
    getOriginalParcelData(originalParcels, stop)
  );

export const accumRemainingStopParcelCodes = (parcelCode) => (acc, parcel) =>
  parcelCode !== parcel.parcelCode
    ? acc.concat([
        { parcelCode: parcel.parcelCode, routeDate: parcel.routeDate },
      ])
    : acc;

export const checkIsEqualParcelCode = (parcelCode) => (parcel) =>
  parcelCode === parcel.parcelCode;

export const parcelsValidation = ({
  stop,
  stopFromApi,
  updatedStops,
  processedRequest,
  processStopIndex,
}) => {
  if (processStopIndex > NO_STOP_INDEX) {
    return {
      updatedStop: {
        ...updatedStops[processStopIndex],
        ...stopFromApi,
        parcel: isAddRequest(processedRequest)
          ? getParcelsWithUpdatedParcelIndexes(
              updatedStops[processStopIndex].parcel,
              stopFromApi.parcel
            )
          : stopFromApi.parcel,
      },
    };
  } else {
    return {
      newStop: {
        ...stopFromApi,
        stopId: stopFromApi.stopId || uuidv4(),
        ...pick(['stopNumber', 'sequenceNumber', 'displayNumber'], stop),
      },
    };
  }
};

export const parcelsRemoval = ({
  stopFromApi,
  updatedStops,
  routeRequests,
}) => {
  const stopNumber = getHighestStopNumber(updatedStops, routeRequests) + 1;
  const sequenceNumber =
    getHighestSequenceNumber(updatedStops, routeRequests) + 1;

  return {
    newStop: {
      ...stopFromApi,
      ...originalTypes.delivery,
      stopNumber,
      sequenceNumber,
      stopId: stopFromApi.stopId || uuidv4(),
      displayNumber: `${sequenceNumber}`,
    },
  };
};
export const hasHighValueParcel = (data = []) =>
  data.some((item) => item.highValue || item.smallsToteParcel);

export const checkNonCadsOnRoute = (stops) =>
  stops.some(({ parcel }) => parcel.some(nonCadScannedParcel));
